import { render, staticRenderFns } from "./Add-form.vue?vue&type=template&id=5408e412&scoped=true&"
import script from "./Add-form.vue?vue&type=script&lang=js&"
export * from "./Add-form.vue?vue&type=script&lang=js&"
import style0 from "./Add-form.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Add-form.vue?vue&type=style&index=1&id=5408e412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408e412",
  null
  
)

export default component.exports